import { createSelector } from '@ngrx/store';
import { GlobalState } from '../../../../store/global';
import { ccDataAdapter, ccLocationsAdapter, ccRowSettingsAdapter } from './cc-list-adapters';
import { selectFocusedRowId } from '../../location-list/state/location-list-selectors';

export const state = (state: GlobalState) => state.locations.ccList;

// CC Data
export const ccDataSelectors = ccDataAdapter.getSelectors();
export const selectCcData = createSelector(state, (state) => state.ccData);
export const selectCcDataArray = createSelector(selectCcData, ccDataSelectors.selectAll);
export const selectCcDataDictionary = createSelector(selectCcData, ccDataSelectors.selectEntities);
export const selectCcDataPerLocation = createSelector(
    selectCcDataDictionary, selectFocusedRowId, (ccDataDictionary, focusedRowId) => {
  return ccDataDictionary[focusedRowId];
});
export const selectCcDataTimestamp = createSelector(selectCcDataPerLocation,
    (ccDataPerLocation) => ccDataPerLocation?.timestamp);

// CC locations
export const ccLocationsSelectors = ccLocationsAdapter.getSelectors();
export const selectCcLocations = createSelector(selectCcDataPerLocation,
    (ccDataPerLocation) => ccDataPerLocation?.ccLocations ?
        ccDataPerLocation.ccLocations :
        ccLocationsAdapter.getInitialState());
export const selectCcLocationsArray = createSelector(
    selectCcLocations, ccLocationsSelectors.selectAll);
export const selectCcLocationsDictionary = createSelector(
    selectCcLocations, ccLocationsSelectors.selectEntities);
export const selectCcLocation = (placeId: string) =>
    createSelector(selectCcLocationsDictionary, (ccLocationsDictionary) => {
      return ccLocationsDictionary[placeId];
});
export const selectCcLocationsCount = createSelector(selectCcLocationsArray,
    (locations) => {
      return locations.length;
    });
export const selectCcLocationsLoading = createSelector(selectCcDataPerLocation,
    (ccDataPerLocation) =>
        ccDataPerLocation?.ccLocationsLoading);

// CC location group
export const selectCcLocationGroup = createSelector(state, (ccLocationsData) => ccLocationsData.ccLocationGroup);

// CC radius
export const selectCcRadius = createSelector(state, (ccLocationsData) => ccLocationsData.ccRadius);

// CC keywords
export const selectCcKeywords = createSelector(state, (ccLocationsData) => ccLocationsData.ccKeywords);

// CC row settings
export const ccRowSettingsSelectors = ccRowSettingsAdapter.getSelectors();
export const selectCcRowSettings = createSelector(selectCcDataPerLocation,
    (ccDataPerLocation) => ccDataPerLocation?.ccRowSettings ?
        ccDataPerLocation?.ccRowSettings :
        ccRowSettingsAdapter.getInitialState());
export const selectCcRowSettingsArray = createSelector(selectCcRowSettings,
    ccRowSettingsSelectors.selectAll);
export const selectCcRowSettingsDictionary = createSelector(selectCcRowSettings,
    ccRowSettingsSelectors.selectEntities);
export const selectSelectedCcRows = createSelector(selectCcRowSettingsArray,
    (ccRows) => {
  return ccRows.filter(ccRow => ccRow.selected);
});
export const selectCcRowSetting = (placeId: string) =>
    createSelector(selectCcRowSettingsDictionary, (state) => {
  return state[placeId];
});

export const selectHoveredCcRowSetting = createSelector(selectCcRowSettingsArray,
    (ccRowSettings => ccRowSettings?.find(rowSetting => rowSetting.hovered)));

export const selectHoveredCCLocation = createSelector(selectCcRowSettingsArray,
    selectCcLocationsDictionary, (ccRowSettings, ccLocations) => {
  const placeId = ccRowSettings?.find(s => s.hovered)?.placeId;
  return ccLocations?.[placeId];
})

// CC list sorting
export const selectCCListSorting = createSelector(state, (state) => state.sorting);

// Continue to nex location
export const selectContinueAfterCreate = createSelector(state,
    (state) => state.continueAfterCreate);

export const selectContinueAfterClaim = createSelector(state,
    (state) => state.continueAfterClaim);

// indicator that the list might be out-of-date
export const selectCCListPossiblyOutOfDate = createSelector(selectCcDataPerLocation,
    (ccDataPerLocation) => ccDataPerLocation?.possiblyOutOfDate);






